import { Model, Nullable, Ordenable, Versionable } from './Model';
import { Question } from './Question';

export default interface Activity extends Model, Ordenable, Versionable {
  name: string;
  type?: ActivityBlockType;
  activityType?: ActivityBlockType;
  questions: Question[];
  author: number;
  inBank: boolean;
  isPublicInBank: boolean;
  isActive?: boolean;
  shuffleQuestions: boolean;
  timeLimit: Nullable<number>;
}

export enum ActivityBlockType {
  REGULAR = 'REGULAR',
  MANUAL_GRADE = 'MANUAL_GRADE',
  OPTIONAL = 'OPTIONAL',
  CONSOLIDATION = 'CONSOLIDATION',
}
